import { NgOptimizedImage } from '@angular/common';
import {
  AfterViewInit,
  Component,
  ElementRef,
  inject,
  input,
  Renderer2,
  viewChild
} from '@angular/core';

@Component({
  selector: 'app-image',
  templateUrl: './image.component.html',
  styleUrl: './image.component.scss',
  imports: [NgOptimizedImage]
})
export class ImageComponent implements AfterViewInit {
  private readonly renderer: Renderer2 = inject(Renderer2);
  public alt = input<string>('');
  public ariaHidden = input<boolean>(true);
  public className = input<string>('');
  public element = viewChild<ElementRef>('image');
  public fillMode = input<boolean>(false);
  public height = input<number>();
  public loading = input<string>('lazy');
  public priority = input<boolean>(false);
  public src = input.required<string>();
  public width = input<number>();

  public ngAfterViewInit(): void {
    const imgElement = this.element()?.nativeElement.querySelector('img');
    if (this.fillMode()) {
      this.renderer.setProperty(imgElement, 'fill', '');
    }
  }
}
